import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  modalContent: {
    maxHeight: '650px',
    height: '650px'
  },
  modalContentPlain: {
    width: '100%',
    '&.isFileEdit': {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      zIndex: '99',
      position: 'absolute',
      '& > div': {
        maxWidth: '100%'
      }
    }
  },
  modalContentWithForm: {
    display: 'flex'
  },
  DocViewer: {
    zIndex: 1000,
    overflowY: 'auto',
    height: 'calc(100% - 52px)',
    '& #pdf-controls': {
      zIndex: 1100,
      justifyContent: 'flex-start'
    }
  },
  formWrapper: {
    padding: '24px',
    width: '334px',
    flexShrink: 0,
    backgroundColor: palette.common.white,
    borderLeft: "1px solid ".concat(palette.shades[300]),
    boxShadow: '0px 4px 24px 0px rgba(85, 100, 119, 0.08)',
    '& .react-datepicker-wrapper': {
      display: 'block',
      '& .MuiFormControl-root': {
        display: 'flex'
      }
    }
  },
  modalFile: {
    width: '100%',
    maxWidth: '946px',
    '& #image-renderer': {
      textAlign: 'center'
    }
  },
  microsoftFileSizePreviewError: {
    width: '100%'
  },
  modalFilePreviewOnly: {
    width: '100%'
  },
  formTitle: {
    marginBottom: '12px'
  },
  field: {
    marginBottom: '16px',
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  rangeDatePicker: {
    '& > div': {
      display: 'block'
    }
  },
  fieldSm: {
    maxWidth: '180px'
  },
  formControlWithSuffix: {
    position: 'relative'
  },
  formControlWithSuffixOutput: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    userSelect: 'none',
    fontSize: 'inherit',
    paddingLeft: '12px',
    position: 'absolute',
    alignItems: 'center',
    visibility: 'hidden',
    lineHeight: 'inherit',
    fontFamily: 'inherit',
    pointerEvents: 'none'
  },
  formControlWithSuffixOutputValue: {
    overflow: 'hidden'
  },
  formControlWithSuffixOutputSuffixValue: {
    height: '100%',
    display: 'flex',
    paddingLeft: '2px',
    alignItems: 'center',
    visibility: 'visible'
  },
  fileController: {
    height: '52px',
    display: 'flex',
    padding: '0 24px',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '&.plain': {
      padding: '0 8px'
    }
  },
  fileControllerEdit: {
    display: 'flex',
    alignItems: 'center'
  },
  drawControllers: {
    display: 'flex',
    alignItems: 'center',
    '&:not(:first-child)': {
      paddingLeft: '16px',
      borderLeft: "1px solid ".concat(palette.shades[300]),
      marginLeft: '16px'
    }
  },
  drawController: {
    borderRadius: '2px',
    '&:not(:last-child)': {
      marginRight: '4px'
    },
    '& span': {
      width: '36px',
      height: '36px',
      display: 'flex',
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: palette.shades[200],
      transition: 'all 0.3s ease',
      '&.active': {
        backgroundColor: palette.shades[300]
      },
      '&:hover': {
        backgroundColor: palette.shades[300]
      }
    },
    '&.disabled span': {
      opacity: '0.5',
      cursor: 'inherit',
      backgroundColor: palette.shades[300]
    }
  },
  colorController: {
    height: '36px',
    margin: '0 8px 0 16px',
    overflow: 'hidden',
    borderRadius: '2px',
    border: '1px solid #4b617c',
    '& input': {
      border: 0,
      padding: 0,
      width: '36px',
      height: '36px',
      cursor: 'pointer',
      appearance: 'none',
      background: 'none',
      '&::-webkit-color-swatch-wrapper': {
        padding: 0
      },
      '&::-webkit-color-swatch': {
        border: 0,
        borderRadius: 0
      },
      '&::-moz-color-swatch,::- moz-focus-inner': {
        border: 0
      },
      '&::-moz-focus-inner': {
        padding: 0
      }
    }
  },
  sizeController: {
    width: '100px',
    marginLeft: '8px',
    '& input': {
      background: '#4b617c',
      borderRadius: '8px',
      height: '7px',
      width: '100%',
      outline: 'none',
      transition: 'background 450ms ease-in',
      appearance: 'none',
      '&::-webkit-slider-thumb': {
        width: '20px',
        height: '20px',
        cursor: 'pointer',
        appearance: 'none',
        borderRadius: '50%',
        background: '#4b617c'
      }
    }
  },
  canvas: {
    width: '946px',
    height: '598px',
    overflow: 'auto',
    backgroundColor: palette.common.white,
    backgroundImage: 'linear-gradient(45deg, #e0e0e0 25%, transparent 25%), linear-gradient(-45deg, #e0e0e0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e0e0e0 75%), linear-gradient(-45deg, transparent 75%, #e0e0e0 75%)',
    backgroundSize: '20px 20px',
    backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
    '.isFileEdit &': {
      width: '1280px',
      height: '647px'
    },
    '&.plain': {
      width: '100%',
      height: '669px'
    }
  },
  canvasWrapper: {
    margin: 'auto',
    overflow: 'hidden',
    '& canvas': {
      transformOrigin: 'top left'
    }
  },
  fileControllerDelete: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    '& .MuiButton-actionButton': {
      border: "1px solid ".concat(palette.shades[300]),
      '& span': {
        marginLeft: '4px'
      }
    },
    '& .MuiButton-actionIcon': {
      margin: '0'
    }
  },
  viewerIconButton: {
    minWidth: '24px !important',
    width: '24px !important',
    height: '24px !important',
    padding: '0 !important',
    border: 'none !important',
    boxShadow: 'none !important',
    backgroundColor: 'transparent !important',
    '&:hover': {
      border: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: "".concat(palette.shades[200], " !important")
    }
  }
});
export default useStyles;